import { RvqPreferenceType } from "../Constants/RvqPreferenceType";
import { BaseRvqPreference } from "./BaseRvqPreference";

class RvqMedicationPreference extends BaseRvqPreference {
    public QuebecVaccinationRegistryId: string;
    public LotId: number;
    public LotNumber: string;
    public Name: string;

    public constructor(init?: Partial<RvqMedicationPreference>) {
        super(init);

        this.Type = RvqPreferenceType.Medication;
        this.DisplayName = init?.Name;
    }

    /**
     * A comparable identifier for the RVQ entity. For example, the practitioner ID for a practitioner preference, or the medication + lot ID for a medication preference.
     */
    public get comparableRvqId(): string {
        return `${this.QuebecVaccinationRegistryId}:${this.LotId}`;
    }
}

export { RvqMedicationPreference };
